import { Suspense, useEffect, useMemo } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes } from "react-router-dom";
import { StaticRouter } from "react-router-dom/server";
import { usePageContext } from "vike-react/usePageContext";
import { store } from "@/store/store";
import GoogleAnalytics from "@/components/common/GoogleAnalytics";
import ScrollToTop from "@/components/common/ScrollTop";
import { setupPushListener } from "@/utils/pushListener";
import RouteLoadingFallback from "@/shared/RouteLoadingFallback";
import { createPublicRoutes, renderAppMainRoutes } from "@/router/appMainRoutes";
import SiteDocumentTitleSync from "@/components/common/SiteDocumentTitleSync";
import Home from "@/pages";

function HomeClientEffects() {
  useEffect(() => {
    void import("aos").then(({ default: Aos }) => {
      Aos.init({
        duration: 1400,
        once: true,
      });
    });
    setupPushListener();
  }, []);
  return null;
}

export default function Page() {
  const isServer = typeof window === "undefined";
  const pageContext = usePageContext();
  const pageProps = (pageContext as { pageProps?: { initialWorkers?: any } }).pageProps || {};
  const location =
    pageContext.urlPathname ||
    (typeof window !== "undefined" ? window.location.pathname + window.location.search : "/");
  const publicRoutes = useMemo(
    () =>
      createPublicRoutes({
        home: <Home initialWorkers={pageProps.initialWorkers} />,
      }),
    [pageProps.initialWorkers]
  );

  const tree = (
    <>
      <GoogleAnalytics />
      <ScrollToTop />
      <SiteDocumentTitleSync />
      <HomeClientEffects />
      <Suspense fallback={<RouteLoadingFallback />}>
        <Routes>{renderAppMainRoutes({ publicRoutes })}</Routes>
      </Suspense>
    </>
  );

  return (
    <Provider store={store}>
      {isServer ? (
        <StaticRouter location={location}>{tree}</StaticRouter>
      ) : (
        <BrowserRouter>{tree}</BrowserRouter>
      )}
    </Provider>
  );
}
